module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/links-78d6ff5ae37acee810cbe95dfc21dc94.svg";